export default __webpack_public_path__ + "static/rovo-dialect-diagram-dark-607c2f5fe5eb7ca08fa0faabacaea984.png";